import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse } from '@/shared/types';
import { mapObjectKeysToSnakeCase } from '@/utils/object-mapper-utils';
import { createApi } from '@reduxjs/toolkit/query/react';

export type ResourceName =
  | "StaticLenders"
  | "StaticIncomeTypes"
  | "StaticExpenseTypes"
  | "StaticLiabilityTypes"
  | "StaticAssetTypes"
  | "StaticGender"
  | "StaticEmploymentTypes"
  | "StaticEmploymentStatus"
  | "StaticEmploymentSector"
  | "StaticCompanyTypes"
  | "StaticApplicantTypes"
  | "StaticIndustryTypes"
  | "StaticResidencyStatus"
  | "StaticRepaymentFrequency"
  | "StaticPropertyType"
  | "StaticCountries"
  | "StaticFrequencies"
  | "StaticAddressTypes"
  | "StaticMaritalStatus"
  | "StaticIncomePeriods"
  | "StaticOccupationCodes"
  | "StaticAddBackTypes"
  | "StaticStates"
  | "StaticNameTitles"
  | "StaticAddressStandards";

export const infynityApi = createApi({
  reducerPath: 'infynityApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchInfynityAllIndividualsData: builder.query<ApiResponse<any>, void>({
      query: () => '/v1/infynity/individuals',
    }),
    fetchInfynityIndividualData: builder.query<
      ApiResponse<any>,
      { individualId: string }
    >({
      query: ({ individualId }) => `/v1/infynity/individuals/${individualId}`,
    }),
    fetchStaticResource: builder.query<ApiResponse<any>, ResourceName>({
      query: (resourceName) => `/v1/infynity/static/${resourceName}`
    }),
    updateInfynityIndividualContactData: builder.mutation<
      ApiResponse<any>,
      { individualId: string; body: any; syncToHubspot?: boolean }
    >({
      query: ({ individualId, body, syncToHubspot = false }) => ({
        url: `/v1/infynity/individuals/${individualId}`,
        params: { syncToHubspot },
        method: 'PUT',
        body: mapObjectKeysToSnakeCase(body),
      }),
    }),
  }),
});

export const {
  useFetchInfynityAllIndividualsDataQuery,
  useFetchInfynityIndividualDataQuery,
  useUpdateInfynityIndividualContactDataMutation,
  useFetchStaticResourceQuery,
} = infynityApi;
